export default function submitOnChange() {
	const elements = document.querySelectorAll("[submit-onchange]");
	elements.forEach((element) =>
		element.addEventListener("change", (event) => submitElement(element))
	);
	function submitElement(element) {
		const form = element.closest("form");
		form.submit();
	}
}
